var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid"},[_c('div',{staticClass:"col-6"},[_c('PairsTable',{attrs:{"items":_vm.sortedPairsOne,"compact":_vm.compact,"select":_vm.handleSelect}})],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('PairsTable',{attrs:{"items":_vm.sortedPairsTwo,"compact":_vm.compact,"select":_vm.handleSelect}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }